import "./style.scss";

const ProgressCircle = ({ totalSteps, currentStep }) => {
  const percentage = (currentStep / totalSteps) * 100;

  // SVG parameters
  const radius = 70;
  const strokeWidth = 12;
  const normalizedRadius = radius - strokeWidth / 2;
  const circumference = normalizedRadius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;
  return (
    <div className="progress-container">
      <div className="progress-wrapper">
        <div className="circle-container">
          {/* Background circle */}
          <svg className="circle-svg" viewBox="0 0 150 150">
            <circle
              className="circle-background"
              strokeWidth={strokeWidth}
              r={normalizedRadius}
              cx="75"
              cy="75"
            />
          </svg>

          {/* Progress circle */}
          <svg className="circle-svg circle-progress" viewBox="0 0 150 150">
            <circle
              className="circle-indicator"
              strokeWidth={strokeWidth}
              strokeDasharray={`${circumference} ${circumference}`}
              style={{ strokeDashoffset }}
              r={normalizedRadius}
              cx="75"
              cy="75"
            />
          </svg>

          {/* Text in center */}
          <div className="progress-text">
            {currentStep}/{totalSteps}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProgressCircle;
